function Play({ dimensions, col = '#000' }) {
  const baseXml = `
    <svg width=${dimensions || '24'} height=${dimensions || '24'} viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0.5 0V14L11.5 7L0.5 0Z" fill=${`"${col}"`}/>
    </svg>
  `;

  return baseXml;
}

export default Play;
